export default "/kiban/_next/static/images/15_6L_2-2-2_stack-75bba47641b57f83c862d9b3183faa4e.png";